import { Component, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../core/auth.service';
import { ResetPasswordRequest } from '../core/reset-password-request';
import { ToastNotificationService } from '../core/toast-notification.service';
import { UIBlockingService } from '../core/ui-blocking.service';

@Component({
  selector: 'app-portal-login-modal',
  templateUrl: './portal-login-modal.component.html',
  providers: [UIBlockingService],
  encapsulation: ViewEncapsulation.None
})

export class PortalLoginModalComponent {
  constructor(private authService: AuthService
    , private blockUI: UIBlockingService
    , private router: Router
    , private notificationService: ToastNotificationService
    , private fb: FormBuilder
    , private activeModal: NgbActiveModal,
  ) { }

  loginForm: FormGroup = new FormGroup({
    userName: new FormControl('userName', Validators.required),
    password: new FormControl('password', Validators.required)
  });
  resetForm: FormGroup = new FormGroup({
    userName: new FormControl('userName', Validators.required),
  });
  displayState = 0;

  validationTriggered = false;
  isBusy = false;
  resettingPassword = false;
  twoFaOptions = [];
  loginStep = 1;
  loginData = {
    Username: "",
    Password: "",
    Client_id: "icp.ams.webapp",
    Grant_type: "password"
  };
  resetData: ResetPasswordRequest = {
    Username: ""
  }
  ngOnInit() {
    this.resetLoginForm();
    this.resetResetForm();
  }


  private resetLoginForm(): void {
    this.loginForm.reset();
    this.loginForm.patchValue({
      userName: '',
      password: ''
    });
  }


  private resetResetForm(): void {
    this.resetForm.reset();
    this.resetForm.patchValue({
      userName: ''
    });
  }

  toSignUp(){
        this.activeModal.close();
        this.router.navigate(['/admin-portal/sign-up/general']); 
  }

  login() {
    if (this.loginForm.invalid) {
      return;
    }
    this.blockUI.start();
    let isBusy = true;
    this.loginData.Username = this.loginForm.get('userName')?.value;
    this.loginData.Password = this.loginForm.get('password')?.value;
    // this.loginData.twoFaCode = this.finalLoginForm.get('secure_code').value;
    this.authService.login(this.loginData)
      .then((response: any) => {

        var roles = response.roles || "";
        this.authService.setToken(response.access_token);
        localStorage.setItem('userName', response.userName);
        localStorage.setItem('userFirstName', response.userFirstName);
        localStorage.setItem('userLastName', response.userLastName);
        localStorage.setItem('userId', response.userId);
        localStorage.setItem('contactId', response.contactId);
        localStorage.setItem('contactType', response.contactType);
        localStorage.setItem('userEmailAddress', this.loginData.Username);
          localStorage.setItem('impersonating', "false");
          localStorage.setItem('membershipLevel', response.membershipLevel);

        this.authService.authentication.isAuthenticated = true;
        this.authService.authentication.userName = this.loginData.Username;
          window.location.reload();
        isBusy = false;
        this.blockUI.stop();
        this.notificationService.success('Success!');
        this.activeModal.close();
        

      }).catch((err/*, status*/) => {

        isBusy = false;
        this.blockUI.stop();
        console.log(err);
        this.notificationService.error('Incorrect username/password');
        this.authService.logout();
      });;
  }
  forgotPassword() {
    if (this.resetForm.invalid) {
      return;
    }
    this.blockUI.start();
    let isBusy = true;
    this.resetData.Username = this.resetForm.get('userName')?.value;
    this.authService.initiateResetPassword(this.resetData)
      .then(() => {
        this.blockUI.stop();
        this.notificationService.success("If your email exists in our system, an email with instructions to reset your password has been sent.");

      }, err => {
        this.blockUI.stop();

        isBusy = false;

        var msg = 'An error has occurred';
        this.notificationService.error(msg);

      });
  }
}
